// extracted by mini-css-extract-plugin
export default {"label":"PrivateCutOff_label__XQ-On","infoIcon":"PrivateCutOff_infoIcon__IdbKv","numberInput":"PrivateCutOff_numberInput__perAv","unitSelect":"PrivateCutOff_unitSelect__5wSZ0"};